// ...existing code... (update all emerald to auburn)
import React from 'react'
import { Home, Heart, Sparkles, ShoppingCart, UtensilsCrossed, Shirt, Bath, Scissors, Users, Footprints } from 'lucide-react'

const Services = () => {
  const homemakerServices = [
    {
      icon: Sparkles,
      title: 'Light Housekeeping',
      description: 'Maintaining a clean and organized living space, including dusting, vacuuming, and tidying up.',
    },
    {
      icon: Shirt,
      title: 'Laundry Services',
      description: 'Complete laundry care including washing, drying, folding, and organizing clothes and linens.',
    },
    {
      icon: UtensilsCrossed,
      title: 'Meal Preparation',
      description: 'Planning and preparing nutritious meals tailored to dietary needs and preferences.',
    },
    {
      icon: ShoppingCart,
      title: 'Grocery Assistance',
      description: 'Help with shopping lists, grocery shopping, and putting away groceries.',
    },
    {
      icon: Home,
      title: 'Household Organization',
      description: 'Organizing living spaces to ensure safety, accessibility, and comfort.',
    },
  ]

  const personalCareServices = [
    {
      icon: Bath,
      title: 'Bathing Assistance',
      description: 'Compassionate support with bathing and maintaining personal hygiene safely.',
    },
    {
      icon: Scissors,
      title: 'Grooming Support',
      description: 'Assistance with hair care, shaving, nail care, and overall appearance.',
    },
    {
      icon: Users,
      title: 'Dressing Assistance',
      description: 'Help with selecting and putting on appropriate clothing comfortably.',
    },
    {
      icon: Footprints,
      title: 'Mobility Support',
      description: 'Safe assistance with walking, transferring, and moving around the home.',
    },
  ]

  return (
    <div className="min-h-screen" data-component-path="client/src/pages/Services.jsx" data-component-line="1:1" data-component-id="client/src/pages/Services.jsx:1:1">
      <section className="bg-gradient-to-br from-auburn-50 via-white to-stone-50 py-20" data-component-path="client/src/pages/Services.jsx" data-component-line="3:3" data-component-id="client/src/pages/Services.jsx:3:3">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/Services.jsx" data-component-line="4:4" data-component-id="client/src/pages/Services.jsx:4:4">
          <div className="text-center max-w-3xl mx-auto" data-component-path="client/src/pages/Services.jsx" data-component-line="5:5" data-component-id="client/src/pages/Services.jsx:5:5">
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6" data-component-path="client/src/pages/Services.jsx" data-component-line="6:6" data-component-id="client/src/pages/Services.jsx:6:6">Our Services</h1>
            <p className="text-xl text-gray-600 leading-relaxed" data-component-path="client/src/pages/Services.jsx" data-component-line="7:7" data-component-id="client/src/pages/Services.jsx:7:7">
              Comprehensive support services designed to help you maintain independence, dignity, and quality of life in the comfort of your own home.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white" data-component-path="client/src/pages/Services.jsx" data-component-line="16:16" data-component-id="client/src/pages/Services.jsx:16:16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/Services.jsx" data-component-line="17:17" data-component-id="client/src/pages/Services.jsx:17:17">
          <div className="text-center mb-16" data-component-path="client/src/pages/Services.jsx" data-component-line="18:18" data-component-id="client/src/pages/Services.jsx:18:18">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-auburn-100 rounded-full mb-6" data-component-path="client/src/pages/Services.jsx" data-component-line="19:19" data-component-id="client/src/pages/Services.jsx:19:19">
              <Home className="w-8 h-8 text-auburn-600" data-component-path="client/src/pages/Services.jsx" data-component-line="20:20" data-component-id="client/src/pages/Services.jsx:20:20" />
            </div>
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4" data-component-path="client/src/pages/Services.jsx" data-component-line="22:22" data-component-id="client/src/pages/Services.jsx:22:22">Homemaker Services</h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-component-path="client/src/pages/Services.jsx" data-component-line="23:23" data-component-id="client/src/pages/Services.jsx:23:23">
              Supporting you with household tasks to maintain a safe, clean, and comfortable living environment
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-component-path="client/src/pages/Services.jsx" data-component-line="27:27" data-component-id="client/src/pages/Services.jsx:27:27">
            {homemakerServices.map((service, index) => (
              <div
                key={index}
                className="bg-stone-50 p-6 rounded-xl hover:shadow-lg transition-shadow duration-200 border border-gray-200"
                data-component-path="client/src/pages/Services.jsx"
                data-component-line="28:28"
                data-component-id="client/src/pages/Services.jsx:28:28"
              >
                <div className="flex flex-col gap-4" data-component-path="client/src/pages/Services.jsx" data-component-line="33:33" data-component-id="client/src/pages/Services.jsx:33:33">
                  <div className="w-12 h-12 bg-auburn-100 rounded-lg flex items-center justify-center flex-shrink-0" data-component-path="client/src/pages/Services.jsx" data-component-line="34:34" data-component-id="client/src/pages/Services.jsx:34:34">
                    <service.icon className="w-6 h-6 text-auburn-600" data-component-path="client/src/pages/Services.jsx" data-component-line="35:35" data-component-id="client/src/pages/Services.jsx:35:35" />
                  </div>
                  <div data-component-path="client/src/pages/Services.jsx" data-component-line="37:37" data-component-id="client/src/pages/Services.jsx:37:37">
                    <h3 className="text-xl font-bold text-gray-900 mb-2" data-component-path="client/src/pages/Services.jsx" data-component-line="38:38" data-component-id="client/src/pages/Services.jsx:38:38">{service.title}</h3>
                    <p className="text-gray-600 leading-relaxed" data-component-path="client/src/pages/Services.jsx" data-component-line="39:39" data-component-id="client/src/pages/Services.jsx:39:39">{service.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-stone-50" data-component-path="client/src/pages/Services.jsx" data-component-line="49:49" data-component-id="client/src/pages/Services.jsx:49:49">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/Services.jsx" data-component-line="50:50" data-component-id="client/src/pages/Services.jsx:50:50">
          <div className="text-center mb-16" data-component-path="client/src/pages/Services.jsx" data-component-line="51:51" data-component-id="client/src/pages/Services.jsx:51:51">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-auburn-100 rounded-full mb-6" data-component-path="client/src/pages/Services.jsx" data-component-line="52:52" data-component-id="client/src/pages/Services.jsx:52:52">
              <Heart className="w-8 h-8 text-auburn-600" data-component-path="client/src/pages/Services.jsx" data-component-line="53:53" data-component-id="client/src/pages/Services.jsx:53:53" />
            </div>
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4" data-component-path="client/src/pages/Services.jsx" data-component-line="55:55" data-component-id="client/src/pages/Services.jsx:55:55">Personal Care Provider Services</h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-component-path="client/src/pages/Services.jsx" data-component-line="56:56" data-component-id="client/src/pages/Services.jsx:56:56">
              Compassionate assistance with personal care needs to help you maintain dignity and independence
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-component-path="client/src/pages/Services.jsx" data-component-line="60:60" data-component-id="client/src/pages/Services.jsx:60:60">
            {personalCareServices.map((service, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-xl hover:shadow-lg transition-shadow duration-200 border border-gray-200"
                data-component-path="client/src/pages/Services.jsx"
                data-component-line="62:62"
                data-component-id="client/src/pages/Services.jsx:62:62"
              >
                <div className="flex flex-col gap-4" data-component-path="client/src/pages/Services.jsx" data-component-line="67:67" data-component-id="client/src/pages/Services.jsx:67:67">
                  <div className="w-12 h-12 bg-auburn-100 rounded-lg flex items-center justify-center flex-shrink-0" data-component-path="client/src/pages/Services.jsx" data-component-line="68:68" data-component-id="client/src/pages/Services.jsx:68:68">
                    <service.icon className="w-6 h-6 text-auburn-600" data-component-path="client/src/pages/Services.jsx" data-component-line="69:69" data-component-id="client/src/pages/Services.jsx:69:69" />
                  </div>
                  <div data-component-path="client/src/pages/Services.jsx" data-component-line="71:71" data-component-id="client/src/pages/Services.jsx:71:71">
                    <h3 className="text-xl font-bold text-gray-900 mb-2" data-component-path="client/src/pages/Services.jsx" data-component-line="72:72" data-component-id="client/src/pages/Services.jsx:72:72">{service.title}</h3>
                    <p className="text-gray-600 leading-relaxed" data-component-path="client/src/pages/Services.jsx" data-component-line="73:73" data-component-id="client/src/pages/Services.jsx:73:73">{service.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-auburn-600" data-component-path="client/src/pages/Services.jsx" data-component-line="83:83" data-component-id="client/src/pages/Services.jsx:83:83">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-component-path="client/src/pages/Services.jsx" data-component-line="84:84" data-component-id="client/src/pages/Services.jsx:84:84">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6" data-component-path="client/src/pages/Services.jsx" data-component-line="85:85" data-component-id="client/src/pages/Services.jsx:85:85">
            How Our Services Support Independence
          </h2>
          <p className="text-xl text-auburn-50 leading-relaxed mb-8" data-component-path="client/src/pages/Services.jsx" data-component-line="88:88" data-component-id="client/src/pages/Services.jsx:88:88">
            Every service we provide is designed with one goal in mind: helping you or your loved ones maintain independence, dignity, and quality of life. Our trained caregivers work closely with families to create personalized care plans that respect individual needs, preferences, and routines. Whether it's help with household tasks or personal care, we're here to ensure safety, comfort, and peace of mind.
          </p>
        </div>
      </section>
    </div>
  )
}

export default Services